import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Card, Collapse, Input, List, Tabs, Typography, Modal, Icon } from 'antd';
import GlobalStateContext from '../../../../context';
import Paragraph from 'antd/lib/typography/Paragraph';
import FileUpload from '../../../../components/FileUpload';
import BreakingNews from './mediaPannelBanners/breakingnews/BreakingNews';
import { BANNER_TYPE_BREAKINGNEWS, BANNER_TYPE_IMAGE } from '../../../../constants';
import { FaEdit, FaEye, FaEyeSlash, FaTrash } from "react-icons/fa";
import MediaPannelBanner from './mediaPannelBanners/MediaPannelBanner';
import _, { merge } from 'lodash';
import './MediaPannelBanners.css';

export default function MediaPannelBanners(props) {
    const [gState, dispatch] = useContext(GlobalStateContext);
    const { banners, active, stream_id, config } = props;
    const [state, setState] = useState(props?.active || [])
    const [editIndex, setEditIndex] = useState(null)
    const [editState, setEditState] = useState({})

    const formRef = useRef()

    // useEffect(() => {
    //     dispatch({
    //         type: "SET_ITEM",
    //         payload: ['mediaPanel', { ...mediaPanel, banners: state }]
    //     })
    //     console.log("Hello", state, mediaPanel,props);
    // }, [state])



    const onchange = (event) => {
        const { name, value } = event.target
        const currentState = banners[editIndex]
        const newInput = _.set({}, name, value)

        const _state = merge({ ...currentState }, editState, newInput)


        setEditState(_state)
    }

    const onImagechange = (data) => {
        const currentState = banners[editIndex]
        const newData = { url: data?.location, name: data?.originalname }
        const newInput = _.set(editState, "image", newData)

        const _state = merge(currentState, newInput)

        setEditState(_state)
    }

    const onSave = () => {
        const current = banners[editIndex];

        banners[editIndex] = {
            ...current,
            ...editState
        }
        console.log("onSave Banner", current, banners[editIndex], editState)

        // props.onAdd("banners", {stream_id: props.stream_id,...banners})
        setEditIndex(null)
        setEditState(null)
    }

    const onUse = (item) => {
        const activeIndex = active.findIndex(e => e?.name == item.name);
        console.log("txt ", activeIndex, item)
        if (activeIndex > -1) {
            active.splice(activeIndex, 1)
        } else {
            const banner = banners.find(e => e?.type == item.type);
            active.push(banner)
        }
        props.onConfigUpdate({ ...gState.mediapanel, stream_id, ["banners"]: active })
    }

    const onEdit = (item) => {
        const index = banners.findIndex(e => e?.name == item.name)
        console.log("INdex", index, banners)
        setEditIndex(index)
    }

    const onDelete = (item) => {
        Modal.confirm({
            title: 'Delete Banner',
            content: 'Are you sure you want to delete this banner? This action cannot be undone.',
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk() {
                props.onDelete("banners", item)
            }
        })
    }

    const onDoneUpload = (data, type = 'banners') => {
        console.log("[x] ", data)

        const newBanner = {
            "name": data?.originalname,
            "title": null,
            "text": null,
            "scroll": false,
            "style": {},
            "type": "image",
            "url": data?.location
        }

        props.onAdd(type, newBanner)
        console.log("[x] new banner", newBanner);
    }

    return (
        <div className="modern-banners-panel">
            {/* Upload Section */}
            <div className="upload-section">
                <FileUpload
                    allowedTypes={['image/jpeg', 'image/png']}
                    maxFileSize={2}
                    showUploadList={false}
                    onComplete={res => onDoneUpload(res.fileList[0]?.response?.data, "banners")}
                    className="upload-container"
                    preview={false}
                    text={"Upload Banner"}
                    data={{ bucket: "viblica-assets" }}
                >
                    <div className="upload-area">
                        <Icon type="upload" className="upload-icon" />
                        <div className="upload-text">Upload Banner</div>
                        <div className="upload-hint">Click or drag image to upload</div>
                    </div>
                </FileUpload>
            </div>

            {/* Banners List */}
            {banners && banners.length > 0 ? (
                <div className="banners-grid gap-2">
                    {banners.map((item, index) => {
                        const isActive = !!active?.find(t => (t?.name == item.name));

                        return (
                            <div key={index} className={`banner-item ${isActive ? "active" : ""}`}>
                                <div className="banner-preview">
                                    <MediaPannelBanner banner={item} theme={config?.theme} rounded={true} />
                                </div>

                                <div className="banner-actions">
                                    <button
                                        className={`flex items-center justify-center gap-1.5 px-4 py-2.5 font-semibold text-sm cursor-pointer transition-all duration-200 rounded-lg min-w-20 ${isActive
                                            ? ' text-white border-blue-500  hover:scale-105'
                                            : ' text-gray-700 border-white/20  hover:text-gray-900 hover:scale-105 hover:border-white/40'
                                            }`}
                                        onClick={() => onUse(item)}
                                        title={isActive ? 'Hide banner' : 'Show banner'}
                                    >
                                        {isActive ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
                                        <span>{isActive ? 'Hide' : 'Show'}</span>
                                    </button>
                                    <button
                                        className="flex items-center justify-center gap-1.5 px-4 py-2.5 bg-white/90 text-gray-700 font-semibold text-sm cursor-pointer transition-all duration-200 rounded-lg  min-w-20 hover:text-gray-900 hover:scale-105 hover:border-white/40"
                                        onClick={() => onEdit(item)}
                                        title="Edit"
                                    >
                                        <FaEdit size={14} />
                                        <span>Edit</span>
                                    </button>
                                    {item.owner === gState.user?._id && (
                                        <button
                                            className="flex items-center justify-center gap-1.5 px-4 py-2.5 bg-red-500/90 text-white font-semibold text-sm cursor-pointer transition-all duration-200 rounded-lg min-w-20 hover:bg-red-600 hover:scale-105"
                                            onClick={() => onDelete(item)}
                                            title="Delete"
                                        >
                                            <FaTrash size={14} />
                                            <span>Delete</span>
                                        </button>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div className="empty-state">
                    <Icon type="picture" className="empty-icon" />
                    <div className="empty-text">No banners created yet</div>
                    <div className="empty-hint">Upload your first banner to get started</div>
                </div>
            )}

            {/* Edit Modal */}
            <Modal
                title="Edit Banner"
                visible={editIndex !== null}
                onCancel={() => { setEditIndex(null); setEditState({}) }}
                onOk={onSave}
                className="banner-edit-modal"
                width={800}
            >
                <div className="edit-layout">
                    {/* Live Preview Section */}
                    <div className="preview-section">
                        <div className="preview-title">Live Preview</div>
                        <div className="preview-container">
                            <MediaPannelBanner
                                banner={editState && Object.keys(editState).length > 0
                                    ? { ...banners[editIndex], ...editState }
                                    : banners?.[editIndex]
                                }
                            />
                        </div>
                    </div>

                    <form ref={formRef} onSubmit={onSave}>
                        {banners?.[editIndex]?.type != BANNER_TYPE_IMAGE && (
                            <div className="edit-form">
                                <div className="form-section">
                                    <label className="form-label">Title</label>
                                    <div className="form-group">
                                        <input
                                            onChange={onchange}
                                            name="title"
                                            className="form-input"
                                            type="text"
                                            placeholder="Enter title"
                                            defaultValue={banners[editIndex]?.title}
                                        />
                                        <div className="color-controls">
                                            <div className="color-control">
                                                <label>Background</label>
                                                <input
                                                    onChange={onchange}
                                                    name="style.title.background"
                                                    type="color"
                                                    defaultValue={banners[editIndex]?.style?.title?.background}
                                                />
                                            </div>
                                            <div className="color-control">
                                                <label>Text Color</label>
                                                <input
                                                    onChange={onchange}
                                                    name="style.title.color"
                                                    type="color"
                                                    defaultValue={banners[editIndex]?.style?.text?.color}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-section">
                                    <label className="form-label">Description/Caption</label>
                                    <div className="form-group">
                                        <textarea
                                            onChange={onchange}
                                            name="text"
                                            className="form-input"
                                            rows="3"
                                            placeholder="Enter caption or description text"
                                            defaultValue={banners[editIndex]?.text}
                                        />
                                        <div className="color-controls">
                                            <div className="color-control">
                                                <label>Background</label>
                                                <input
                                                    onChange={onchange}
                                                    name="style.text.background"
                                                    type="color"
                                                    defaultValue={banners[editIndex]?.style?.text?.background}
                                                />
                                            </div>
                                            <div className="color-control">
                                                <label>Text Color</label>
                                                <input
                                                    onChange={onchange}
                                                    name="style.text.color"
                                                    type="color"
                                                    defaultValue={banners[editIndex]?.style?.text?.color}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {banners?.[editIndex]?.type == BANNER_TYPE_IMAGE && (
                            <div className="edit-form">
                                <div className="image-preview">
                                    <img
                                        className="current-image"
                                        src={banners[editIndex]?.image?.url}
                                        alt="Current banner"
                                    />
                                </div>
                                <FileUpload
                                    allowedTypes={['image/jpeg', 'image/png']}
                                    maxFileSize={2}
                                    showUploadList={false}
                                    onComplete={res => onImagechange(res.fileList[0]?.response?.data)}
                                    className="upload-container"
                                    preview={false}
                                    text={"Change Image"}
                                    data={{ bucket: "viblica-assets" }}
                                >
                                    <button type="button" className="change-image-btn">
                                        <Icon type="upload" />
                                        Change Image
                                    </button>
                                </FileUpload>
                            </div>
                        )}
                    </form>
                </div>
            </Modal>
        </div>
    )
}
